import { useEffect } from "react";
import { useAuth, useClerk } from "@clerk/react";
import { Navigate, useLocation } from "react-router-dom";
import { useEntitlement } from "../lib/EntitlementContext";

export default function AuthEntry({ mode = "signIn" }) {
  const { isLoaded, isSignedIn } = useAuth();
  const { openSignIn, openSignUp } = useClerk();
  const location = useLocation();
  const { status, hasActiveEntitlement, isEntitlementLoading } = useEntitlement();

  useEffect(() => {
    if (!isLoaded || isSignedIn) return;

    if (mode === "signUp") {
      openSignUp();
    } else {
      openSignIn();
    }
  }, [isLoaded, isSignedIn, mode, openSignIn, openSignUp]);

  if (!isLoaded || isEntitlementLoading) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center text-zinc-400">
        Loading account...
      </div>
    );
  }

  if (isSignedIn) {
    const from = location.state?.from?.pathname;

    if (hasActiveEntitlement) {
      return <Navigate to={from || "/enter-studio"} replace />;
    }

    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center text-zinc-400">
      Opening login...
    </div>
  );
}
